// src/utils/helpers.js

// ─── DATE / TIME ─────────────────────────────────────────────────────────────

export const todayISO = () => new Date().toISOString().split('T')[0];

export const formatDate = (iso) => {
  if (!iso) return '—';
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
};

export const formatDateTime = (iso, time) => `${formatDate(iso)} às ${time}`;

export const formatCurrency = (value) =>
  Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export const isoToDisplay = (iso) => {
  if (!iso) return '';
  const date = new Date(iso + 'T00:00:00');
  return date.toLocaleDateString('pt-BR', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' });
};

export const isFuture = (isoDate) => isoDate >= todayISO();

export const isToday = (isoDate) => isoDate === todayISO();

// Generate all 30-min slots between startHour and endHour
export const generateSlots = (startHour = 8, endHour = 18) => {
  const slots = [];
  for (let h = startHour; h < endHour; h++) {
    slots.push(`${String(h).padStart(2, '0')}:00`);
    slots.push(`${String(h).padStart(2, '0')}:30`);
  }
  return slots;
};

export const ALL_SLOTS = generateSlots(8, 19);

// Calendar helpers
export const getDaysInMonth = (year, month) =>
  new Date(year, month + 1, 0).getDate();

export const getFirstDayOfMonth = (year, month) =>
  new Date(year, month, 1).getDay();

export const monthName = (month) =>
  ['Janeiro','Fevereiro','Março','Abril','Maio','Junho',
   'Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'][month];

// ─── STATUS ───────────────────────────────────────────────────────────────────

export const STATUS_LABELS = {
  pending:        'Pendente',
  confirmed:      'Confirmado',
  waitingConfirm: 'Ag. Confirmação',
  cancelled:      'Cancelado',
};

export const STATUS_COLORS = {
  pending:        'warning',
  confirmed:      'success',
  waitingConfirm: 'info',
  cancelled:      'danger',
};

export const STATUS_ICONS = {
  pending:        '⏳',
  confirmed:      '✓',
  waitingConfirm: '📲',
  cancelled:      '✗',
};

// ─── INITIALS ────────────────────────────────────────────────────────────────

export const getInitials = (name = '') => {
  const parts = name.trim().split(' ');
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

// ─── AVATAR COLORS ────────────────────────────────────────────────────────────
const AVATAR_COLORS = ['#e94560','#3b82f6','#10b981','#f5a623','#8b5cf6','#f59e0b','#06b6d4'];
export const avatarColor = (str = '') => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) hash = str.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

// ─── FILTER / SORT ────────────────────────────────────────────────────────────
export const filterAppointments = (appointments, filters) => {
  return appointments.filter((a) => {
    if (filters.status && filters.status !== 'all' && a.status !== filters.status) return false;
    if (filters.professionalId && a.professionalId !== filters.professionalId) return false;
    if (filters.date && a.date !== filters.date) return false;
    if (filters.procedureId && a.procedureId !== filters.procedureId) return false;
    if (filters.search) {
      const q = filters.search.toLowerCase();
      if (!a.clientName?.toLowerCase().includes(q) &&
          !a.procedureName?.toLowerCase().includes(q) &&
          !a.professionalName?.toLowerCase().includes(q)) return false;
    }
    return true;
  });
};

// ─── CASHFLOW ─────────────────────────────────────────────────────────────────
export const calcTotal = (appointments) =>
  appointments.filter((a) => a.done).reduce((sum, a) => sum + Number(a.price || 0), 0);
